// extracted by mini-css-extract-plugin
export default {"button":"EditButton_button__lQx-a","icon":"EditButton_icon__a1eg+"};